import { Badge } from '@/components/ui/badge';

type SubmissionStatus = 'unsubmitted' | 'requirement_missing' | 'submitted' | null;

// The three-way project submission status shown wherever a team's project is
// referenced: the teams table and the team/hacker profile pages.
export function SubmissionStatusBadge({ status }: { status: SubmissionStatus }) {
  if (!status) {
    return (
      <Badge variant="outline" className="text-muted-foreground">
        No project
      </Badge>
    );
  }
  if (status === 'submitted') {
    return (
      <Badge className="bg-green-100 text-green-800 hover:bg-green-100">
        Submitted
      </Badge>
    );
  }
  if (status === 'requirement_missing') {
    return (
      <Badge className="bg-amber-100 text-amber-800 hover:bg-amber-100">
        Missing requirement
      </Badge>
    );
  }
  return <Badge variant="secondary">Unsubmitted</Badge>;
}
